export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_s_01_f_mask.a10a1d17.png";